// extracted by mini-css-extract-plugin
export default {"Root":"GoogleCustomerIdModal_Root__KKQjl","Content":"GoogleCustomerIdModal_Content__1YmZ3"};